import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { updateProfile } from "firebase/auth";

function UserProfile() {
  const [profile, setProfile] = useState({
    name: "",
    mobile: "",
    photoURL: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      if (!auth.currentUser) return;
      const docRef = doc(db, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setProfile(docSnap.data());
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const uid = auth.currentUser.uid;

      await setDoc(doc(db, "users", uid), profile);

      await updateProfile(auth.currentUser, {
        displayName: profile.name,
        photoURL: profile.photoURL,
      });

      alert("Profile updated!");
    } catch (err) {
      alert("Error updating profile: " + err.message);
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "20px auto", textAlign: "center" }}>
      <h2>My Profile</h2>
      <img
        src={profile.photoURL || "https://via.placeholder.com/150"}
        alt="Profile"
        style={{ width: "100px", borderRadius: "50%", marginBottom: "10px" }}
      />
      <div>
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={profile.name}
          onChange={handleChange}
          style={{ width: "100%", margin: "5px 0" }}
        />
        <input
          type="text"
          name="mobile"
          placeholder="Mobile"
          value={profile.mobile}
          onChange={handleChange}
          style={{ width: "100%", margin: "5px 0" }}
        />
        <input
          type="text"
          name="photoURL"
          placeholder="Profile Image URL"
          value={profile.photoURL}
          onChange={handleChange}
          style={{ width: "100%", margin: "5px 0" }}
        />
      </div>
      <button onClick={handleSave} style={{ marginTop: "15px" }}>
        Save Profile
      </button>
    </div>
  );
}

export default UserProfile;
